import CryptoJS from 'crypto-js/core';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import SHA3 from 'sha3';
import { Logger } from '../../feature/logger/logger';

const ENCRYPT_SALT = 'STIHL';

export class CryptoUtils {
  static createPKCEData(redirectPath?: string): {
    codeChallenge: string;
    codeVerifier: string;
    state: string;
    csrf: string;
  } {
    Logger.debug('createPKCEData', 'Creating PKCE data');
    const randomString = CryptoJS.lib.WordArray.random(32);
    const codeVerifier = CryptoUtils.cleanBase64String(Base64.stringify(randomString));
    const codeChallenge = CryptoUtils.cleanBase64String(Base64.stringify(sha256(codeVerifier)));
    const csrf = CryptoJS.lib.WordArray.random(12).toString();
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('id_token_hint');
    const pathSearch = `${window.location.pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`;
    const state = `${redirectPath ?? pathSearch}|${csrf}|${this.encodeToBase64Url(
      JSON.stringify({
        analytics: { ga_referrer: document.referrer },
      })
    )}`;

    return {
      codeChallenge,
      codeVerifier,
      state,
      csrf,
    };
  }

  static hashWithSalt(id: string): string {
    const hash = new SHA3(256);
    return hash.update(id + ENCRYPT_SALT).digest('hex');
  }

  static hashSha256 = (input = '') => sha256(Utf8.parse(input)).toString();

  private static cleanBase64String(str: string): string {
    return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  }

  /**
   * Encodes a string to a URL-safe base64 format.
   * @param str The original string to be encoded.
   * @returns A URL-safe base64 encoded string.
   */
  public static encodeToBase64Url(str: string): string {
    const base64 = Base64.stringify(Utf8.parse(str));

    // Replace characters to make the base64 string URL-safe
    return this.cleanBase64String(base64);
  }

  /**
   * Decodes a URL-safe base64 encoded string back to the original string.
   * @param str The URL-safe base64 string to be decoded.
   * @returns The original decoded string.
   */
  public static decodeFromBase64Url(str: string): string {
    // Calculate the required padding based on the length of the string
    const padding = str.length % 4 === 0 ? 0 : 4 - (str.length % 4);

    // Replace '-' with '+', '_' with '/', and add '=' padding if necessary
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat(padding);

    return Base64.parse(base64).toString(Utf8);
  }
}
